import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Pricing from "./components/Pricing";
import Contact from "./components/Contact";
import PrivacyPolicy from "./components/PrivacyPolicy";
import VideoInstructions from "./components/VideoInstructions";
import translations from "./translations/translations";

import "./styles/sections.css";

const App = () => {
  const location = useLocation();
  const [language, setLanguage] = useState("en");

  // Check for language in URL (e.g., ?lang=pl) and update state
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const langFromURL = urlParams.get("lang"); // Get 'lang' from URL

    // Load from URL or fallback to localStorage
    const savedLanguage = langFromURL || localStorage.getItem("preferredLanguage") || "en";

    if (savedLanguage !== language) {
      setLanguage(savedLanguage);
      localStorage.setItem("preferredLanguage", savedLanguage); // Save preference
    }
  }, [language, location.search]); // Re-run when URL changes

  const translation = translations[language] || translations["en"]; // Default to English

  return (
    <Routes>
      {/* Home Page Route */}
      <Route
        path="/"
        element={
          <>
            <Header language={language} setLanguage={setLanguage} />
            <Hero translations={translation} />
            <Features translations={translation} />
            <VideoInstructions translations={translation} videoId="RHSeP0NsizA" />
            <Pricing translations={translation} />
            <Contact translations={translation} />
            <Footer translations={translation} />
          </>
        }
      />

      {/* Privacy Policy Page */}
      <Route path="/privacy-policy" element={<PrivacyPolicy translations={translation} />} />
    </Routes>
  );
};

export default App;